module.exports = __webpack_public_path__ + "img/264.5292cabb.png";